<template>
  <div class="csv-import-medicines">
    <login-for-management v-slot="{ clinics }">
      <base-csv-import
        v-slot="{ uploadCsv }"
        titleText="薬剤物品インポート"
        url="/csv-import-medicines"
        :clinics="clinics"
        :initialCsvData="makeInitialCsvData()"
        :makeConfirmText="makeConfirmText"
      >
        <div>大分類</div>
        <input
          type="file"
          @change="uploadCsv($event, 'medicineLargeClasses')"
        />
        <div>中分類</div>
        <input
          type="file"
          @change="uploadCsv($event, 'medicineMediumClasses')"
        />
        <div>小分類</div>
        <input
          type="file"
          @change="uploadCsv($event, 'medicineSmallClasses')"
        />
        <div>薬剤物品</div>
        <input type="file" @change="uploadCsv($event, 'medicines')" />
      </base-csv-import>
    </login-for-management>
  </div>
</template>

<script>
import BaseCsvImport from '@/components/pages/BaseCsvImport'
import LoginForManagement from '@/components/pages/LoginForManagement'
export default {
  name: 'CsvImportMedicines',

  components: {
    BaseCsvImport,
    LoginForManagement
  },

  methods: {
    makeInitialCsvData() {
      return {
        medicineLargeClasses: null,
        medicineMediumClasses: null,
        medicineSmallClasses: null,
        medicines: null
      }
    },
    makeConfirmText(targetClinic) {
      return `「${targetClinic.name}」の薬剤物品データについて、\nインポートを行います。実行しますか？`
    }
  }
}
</script>

<style lang="scss" scoped></style>
